module.exports = __webpack_public_path__ + "media/images/login/login-photo-ac6991b57a0180972fd13d6404507d1a.png";